export const SEARCH_PARAM_FIELD = "searchParam";
export const SEARCH_VALUE_FIELD = "searchValue";
export const VERSION_FIELD = "version";
export const SEARCH_RESULTS_FIELD = "searchResults";
export const SEARCH_PAGE_FIELD = "page";
export const SEARCH_RESULTS_TOTAL_FIELD = "searchResultsTotal";
export const PAGE_SIZE = 25;
export const SEARCH_PARAMS = {
  ACCOUNT: "account",
  ACCOUNTS: "accounts",
  COMPANY_NAME: "companyName",
  USERNAME: "username",
};

export const SEARCH_USER_TABLE_HEADERS = [
  "LOGON ID",
  "ACCOUNT",
  "BUSINESS UNIT",
  "ACTUAL APP VERSION",
  "EXPECTED APP VERSION",
];

export const SEARCH_CUSTOMER_TABLE_HEADERS = [
  "ACCOUNT ID",
  "BUSINESS UNIT",
  "NAME",
];

export const CUSTOMER_COLUMS = [
  {
    width: 180,
    label: "ACCOUNT ID",
    dataKey: "account",
  },
  {
    width: 180,
    label: "BUSINESS UNIT",
    dataKey: "businessUnit",
  },
  {
    width: 320,
    label: "NAME",
    dataKey: "customername",
  },
];

export const USER_COLUMS = [
  {
    width: 240,
    label: "LOGON ID",
    dataKey: "username",
  },
  {
    label: "ACCOUNT",
    dataKey: "account",
  },
  {
    label: "BUSINESS UNIT",
    dataKey: "businessUnit",
  },
  {
    label: "ACTUAL APP VERSION",
    dataKey: "dpdLocalAppVersionActual",
  },
  {
    label: "EXPECTED APP VERSION",
    dataKey: "dpdLocalAppVersionExpected",
  },
];
